/**
 * UI Utility Functions
 * Vanilla JavaScript alternatives to jQuery animations
 */

/**
 * Vanilla JavaScript slideUp animation (jQuery-like)
 * @param {HTMLElement} element - Element to animate
 * @param {number} duration - Animation duration in milliseconds
 * @param {Function} callback - Optional callback to run after animation
 */
export function slideUp(element, duration = 300, callback) {
	element.style.transitionProperty = 'height, margin, padding';
	element.style.transitionDuration = duration + 'ms';
	element.style.boxSizing = 'border-box';
	element.style.height = element.offsetHeight + 'px';
	element.offsetHeight; // Force reflow

	element.style.overflow = 'hidden';
	element.style.height = 0;
	element.style.paddingTop = 0;
	element.style.paddingBottom = 0;
	element.style.marginTop = 0;
	element.style.marginBottom = 0;

	window.setTimeout(() => {
		element.style.display = 'none';
		element.style.removeProperty('height');
		element.style.removeProperty('padding-top');
		element.style.removeProperty('padding-bottom');
		element.style.removeProperty('margin-top');
		element.style.removeProperty('margin-bottom');
		element.style.removeProperty('overflow');
		element.style.removeProperty('transition-duration');
		element.style.removeProperty('transition-property');
		if (callback) callback();
	}, duration);
}

/**
 * Vanilla JavaScript slideDown animation (jQuery-like)
 * @param {HTMLElement} element - Element to animate
 * @param {number} duration - Animation duration in milliseconds
 * @param {Function} callback - Optional callback to run after animation
 */
export function slideDown(element, duration = 300, callback) {
	element.style.removeProperty('display');
	let display = window.getComputedStyle(element).display;

	if (display === 'none') display = 'block';
	element.style.display = display;

	const height = element.offsetHeight;
	element.style.overflow = 'hidden';
	element.style.height = 0;
	element.style.paddingTop = 0;
	element.style.paddingBottom = 0;
	element.style.marginTop = 0;
	element.style.marginBottom = 0;
	element.offsetHeight; // Force reflow

	element.style.boxSizing = 'border-box';
	element.style.transitionProperty = 'height, margin, padding';
	element.style.transitionDuration = duration + 'ms';
	element.style.height = height + 'px';
	element.style.removeProperty('padding-top');
	element.style.removeProperty('padding-bottom');
	element.style.removeProperty('margin-top');
	element.style.removeProperty('margin-bottom');

	window.setTimeout(() => {
		element.style.removeProperty('height');
		element.style.removeProperty('overflow');
		element.style.removeProperty('transition-duration');
		element.style.removeProperty('transition-property');
		if (callback) callback();
	}, duration);
}
